import Cookies from "js-cookie";

if (Cookies.get("currency") == undefined) {
  let currencyLabel;
  currencyLabel = 'eur';
  Cookies.set("currency", currencyLabel, { expires: 7, path: "/" });
  $('.header-icons__currency .current').html(currencyLabel.toUpperCase());
}

$(".header-icons__currency").niceSelect();
$(".nav-btn").click(function () {
  $(this).toggleClass("nav-btn_close");
  if ($(".dropdown-menu").hasClass("slideDown")) {
    $(".nav-primary")
      .find(".dropdown-menu")
      .slideUp()
      .removeClass("slideDown");

    $(".nav-primary")
      .find("a")
      .removeClass("underline")
      .removeClass("underline_sub");
  }
  $(".nav-primary").toggleClass("active-menu");
  if ($(this).hasClass("nav-btn_close")) {
    $("body").addClass("fixed-body");
  } else {
    $("body").removeClass("fixed-body");
  }
});

if ($(window).width() < 992) {
  var isDisabled = false;
} else {
  isDisabled = true;
}
var mobileMenu = function () {
  $("#primary-menu .dropdown > a").bind("click", function (e) {
    if (!isDisabled) {
      e.preventDefault();
      if (
        $(this)
          .next(".dropdown-menu")
          .hasClass("slideDown")
      ) {
        $(this)
          .removeClass("underline")
          .removeClass("underline_sub")
          .next(".dropdown-menu")
          .slideUp()
          .removeClass("slideDown");

        if ($(this).hasClass("dropdown-toggle")) {
          $(".nav-primary")
            .find("a")
            .removeClass("underline")
            .removeClass("underline_sub");
          $(".nav-primary")
            .find(".dropdown-menu")
            .slideUp()
            .removeClass("slideDown");
        }
      } else {
        $(this)
          .next(".dropdown-menu")
          .slideDown()
          .addClass("slideDown");

        if ($(this).hasClass("dropdown-toggle")) {
          $(this).addClass("underline");
        } else {
          $(this).addClass("underline_sub");
        }
      }
      if (
        $(this)
          .parent()
          .siblings(".dropdown")
          .children(".dropdown-menu")
          .hasClass("slideDown")
      ) {
        $(this)
          .parent()
          .siblings(".dropdown")
          .children(".dropdown-menu")
          .slideUp()
          .removeClass("slideDown");
        $(this)
          .parent()
          .siblings(".dropdown")
          .children("a")
          .removeClass("underline_sub");
      }
    }
  });
  isDisabled = false;
};

$(window).resize(function () {
  if ($(window).width() > 992) {
    isDisabled = true;
    $(".nav-primary").removeClass("active-menu");
    $(".nav-btn").removeClass("nav-btn_close");
    $("html, body").css({
      overflow: "auto",
      height: "auto",
    });
    $(".nav-primary")
      .find("a")
      .removeClass("underline")
      .removeClass("underline_sub");
    $(".nav-primary")
      .find(".dropdown-menu")
      .css("display", "")
      .removeClass("slideDown");
  } else {
    isDisabled = false;
    $(".dropdown > a").unbind("click");
    mobileMenu();
  }
});
if (!isDisabled) {
  $(".dropdown > a").unbind("click");
  mobileMenu();
}

$(".wpml-ls-current-language > a").click(function (e) {
  e.preventDefault();
});

$(".header-icons__currency").on("change", function () {
  let current_currency = $(this).val();
  Cookies.set("currency", current_currency, { expires: 7, path: "/" });
  location.reload();
  return false;
});


$("html").click(function (e) {
  let lsSubMenu = $(".header-icons__item_ls").find(".sub-menu");
  if (
    $(e.target).hasClass("header-icons__item_ls") ||
    $(e.target).hasClass("wpml-ls-flag")
  ) {
    $(".header-icons__item_ls").toggleClass("active");

    $(".header-icons__item_ls")
      .find(".sub-menu")
      .toggleClass("active");
  } else {
    lsSubMenu.removeClass("active");
    $(".header-icons__item_ls").removeClass("active");
  }
});



// WEBPACK FOOTER //
// ./scripts/modules/header.js